// extracted by mini-css-extract-plugin
export default {"productGrid":"WY-z","centerLink":"XY-z","productSection":"YY-z","item":"ZY-z","ctaButton":"_Y-z"};